export const USER_LOADED_STATUS = {
  BASIC: 1,
  SEARCH: 2,
  FULL: 3,
};
